import Link from './link'
import NavLink from './nav-link'
import PrivateRoute from './private-route'
import LoginRoute from './login-route'

module.exports = {
  Link,
  NavLink,
  PrivateRoute,
  LoginRoute
}



// WEBPACK FOOTER //
// /home/ec2-user/esquina/esquina/lib/frontend/router/index.js